import { useEffect, useRef, useState } from "react";
import { faDownload, faTrash, faFile } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CrudApi from "@serie3/common/api/crudApi";
import downloadHandler from "@serie3/freelancesplaceapi/Domain/Shared/downloadHandler";
import DocumentsConfig from "@serie3/freelancesplaceapi/Config/Documents/DocumentsConfig";

const LazyBinaryImage = ({ fileId }) => {
  const ref = useRef(null);
  const [blobUrl, setBlobUrl] = useState(null);
  const [isImage, setIsImage] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      async ([entry]) => {
        if (entry.isIntersecting) {
          observer.disconnect();
          const response = await CrudApi.getBinary(DocumentsConfig.endpoints.preview + fileId);
          if (response?.data) {
            const contentType = response.headers?.["content-type"] || "";
            if (contentType.startsWith("image/")) {
              setBlobUrl(URL.createObjectURL(response.data));
              setIsImage(true);
            } else {
              setBlobUrl("__non-image__");
            }
          }
        }
      },
      { rootMargin: "150px" }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [fileId]);

  useEffect(() => {
    return () => { if (blobUrl && blobUrl !== "__non-image__") URL.revokeObjectURL(blobUrl); };
  }, [blobUrl]);

  return (
    <div ref={ref} style={{ height: 160, background: "#f4f5f7", display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden" }}>
      {blobUrl === null ? (
        <div className="skeleton" style={{ width: "100%", height: "100%" }} />
      ) : isImage ? (
        <img src={blobUrl} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
      ) : (
        <FontAwesomeIcon icon={faFile} style={{ fontSize: "2.5rem", color: "#bdbdbd" }} />
      )}
    </div>
  );
};

const DocumentCard = ({ document, CardButtons, deleteFunction, onPreview }) => {
  const downloadUrl = DocumentsConfig.endpoints.preview + document.id;

  const Buttons = () =>
    CardButtons ? (
      <CardButtons />
    ) : (
      <div style={{ display: "flex", gap: "6px" }}>
        <button
          onClick={(e) => { e.stopPropagation(); downloadHandler(downloadUrl, document.name); }}
          style={{ background: "#e8f0fe", color: "#1a73e8", border: "none", borderRadius: "6px", width: "30px", height: "30px", cursor: "pointer", display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: "0.8rem" }}
        >
          <FontAwesomeIcon icon={faDownload} />
        </button>
        <button
          onClick={(e) => { e.stopPropagation(); deleteFunction && deleteFunction(document); }}
          style={{ background: "#ffebee", color: "#c62828", border: "none", borderRadius: "6px", width: "30px", height: "30px", cursor: "pointer", display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: "0.8rem" }}
        >
          <FontAwesomeIcon icon={faTrash} />
        </button>
      </div>
    );

  return (
    <div
      onClick={() => onPreview && onPreview(document)}
      style={{ background: "#fff", borderRadius: "12px", boxShadow: "0 2px 12px rgba(0,0,0,0.08)", overflow: "hidden", display: "flex", flexDirection: "column", cursor: onPreview ? "pointer" : "default", transition: "box-shadow 0.15s" }}
      onMouseEnter={(e) => { if (onPreview) e.currentTarget.style.boxShadow = "0 6px 24px rgba(0,0,0,0.14)"; }}
      onMouseLeave={(e) => { e.currentTarget.style.boxShadow = "0 2px 12px rgba(0,0,0,0.08)"; }}
    >
      <div style={{ padding: "12px 14px 10px", borderBottom: "1px solid #f0f0f0", display: "flex", alignItems: "center", gap: "8px" }}>
        <FontAwesomeIcon icon={faFile} style={{ color: "#1a73e8", fontSize: "0.85rem", flexShrink: 0 }} />
        <span style={{ fontWeight: 600, fontSize: "0.85rem", color: "#212121", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
          {document.name}
        </span>
      </div>

      <LazyBinaryImage fileId={document.id} />

      <div style={{ padding: "10px 14px", borderTop: "1px solid #f0f0f0", display: "flex", justifyContent: "flex-end", background: "#fff" }}>
        <Buttons />
      </div>
    </div>
  );
};

export default DocumentCard;
